export const NOTE_SOURCES = {
  WEBAPP: 'WEBAPP',
  HUBSPOT: 'HUBSPOT',
  SUCCESS_PLAN: 'SUCCESS_PLAN',
  INTERCOM: 'INTERCOM',
  PLANHAT: 'PLANHAT',
};

export const NOTE_SOURCE_USER_TYPE = {
  VELARIS_USER: 1,
  NON_VELARIS_USER: 2,
  VELARIS_CONTACT: 3,
};

export const NOTE_VENDORS = {
  HUBSPOT: {
    value: NOTE_SOURCES.HUBSPOT,
    displayName: 'hubspot',
  },
  INTERCOM: {
    value: NOTE_SOURCES.INTERCOM,
    displayName: 'intercom',
  },
  PLANHAT: {
    value: NOTE_SOURCES.PLANHAT,
    displayName: 'planhat',
  },
};

export const USER_TYPE_TO_DETAIL_KEY = {
  [NOTE_SOURCE_USER_TYPE.VELARIS_USER]: 'UserId',
  [NOTE_SOURCE_USER_TYPE.VELARIS_CONTACT]: 'ContactId',
  [NOTE_SOURCE_USER_TYPE.NON_VELARIS_USER]: 'NonVelarisUser',
};
